import { NodeTypeEnum, StorageManagedByEnum } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import { SelectOption } from '@shared/components/form/select-form-field';

export interface NodeTypeOption extends SelectOption {}

export const nodeTypeOptions: NodeTypeOption[] = [
  {
    label: 'Factory',
    value: NodeTypeEnum['factory'],
    icon: <Icons.factory className="size-6 text-primary-400" />,
  },
  {
    label: 'Warehouse',
    value: NodeTypeEnum['warehouse'],
    icon: <Icons.warehouse className="size-6 text-primary-400" />,
  },
  {
    label: 'Distribution centre',
    value: NodeTypeEnum['distribution_centre'],
    icon: <Icons.container className="size-6 text-primary-400" />,
  },
  {
    label: 'Retail store',
    value: NodeTypeEnum['retail_store'],
    icon: <Icons.store className="size-6 text-primary-400" />,
  },
  {
    label: 'Restaurant',
    value: NodeTypeEnum['restaurant'],
    icon: <Icons.utensils className="size-6 text-primary-400" />,
  },
  {
    label: 'Central kitchen',
    value: NodeTypeEnum['central_kitchen'],
    icon: <Icons.chefHat className="size-6 text-primary-400" />,
  },
  {
    label: 'Transport hub',
    value: NodeTypeEnum['transport_hub'],
    icon: <Icons.arrowUpDown className="size-6 text-primary-400" />,
  },
  {
    label: 'Depot',
    value: NodeTypeEnum['depot'],
    icon: <Icons.arrowUpDown className="size-6 text-primary-400" />,
  },
];

export const storageManagedByOptions: SelectOption[] = [
  {
    label: 'Managed by us',
    value: StorageManagedByEnum['company'],
  },
  {
    label: 'Managed by client',
    value: StorageManagedByEnum['client'],
  },
  {
    label: 'Outsourced',
    value: StorageManagedByEnum['third_party'],
  },
  {
    label: 'Managed by supplier',
    value: StorageManagedByEnum['supplier'],
  },
  {
    label: 'Downstream',
    value: StorageManagedByEnum['downstream'],
    disabled: true,
  },
];
